
export function authFetch(url, method, body ) {
    return fetch(url, {
            method: method,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwt_auth_token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: body
        })
        .then((res) => {
            if (res.status === 700) {
                localStorage.clear();
                return { data: {
                    needRelogin: true,
                    errorMessage: 'Sesi berakhir. Tolong logout atau refresh untuk logout.',
                }};
            } else if (res.status > 200) {
                return res.json().then(data => {
                    if (data.data && data.data.length > 0) {
                        return { data: { errorMessage: data.data[0].error_message } };    
                    }
                    return { data: { errorMessage: data.header.error_message } };
                })
            }
            return res.json()
        })
}